import { render, staticRenderFns } from "./ABTests.vue?vue&type=template&id=5d558628&scoped=true"
import script from "./ABTests.vue?vue&type=script&lang=js"
export * from "./ABTests.vue?vue&type=script&lang=js"
import style0 from "./ABTests.vue?vue&type=style&index=0&id=5d558628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d558628",
  null
  
)

export default component.exports